import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';

@Directive(
    {
    selector: '[scaleVertically]',
    standalone: false
}
)
export class ScaleVerticallyDirective {

    @Input() scaleVertically: any;

    constructor(public el: ElementRef, public renderer: Renderer2) { }

    ngOnInit() {
        setTimeout(()=>{
            this.refresh();
        }, 100);
    }

    @HostListener('window:resize')
    onWindowResize() {
        setTimeout(()=>{
            this.refresh();
        }, 100);
    }

    private refresh() {
        let heightToSet = window.innerHeight - this.getOffsetTop() - this.scaleVertically;
        this.setHeight(heightToSet);

        // console.log("height to set = " + heightToSet);
        // console.log("native element offset = " + this.el.nativeElement.offsetTop);
        // console.log("inner = " + window.innerHeight);
        // console.log("outer = " + window.outerHeight);
        // console.log("offset = " + this.getOffsetTop());
        // console.log("scalle = " + this.scaleVertically);
    }
    
    private getOffsetTop(): number {
        //80 is navbar height
        return 80 + this.el.nativeElement.offsetTop;
    }

    private setHeight(height: number){
        this.renderer.setStyle(this.el.nativeElement, 'height', height+"px");
    }
}